import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Input, Modal, PageHead, useToast } from '@w7/ui'
import { sessionApi } from '@/api/sessionApi'

type Rate = {
  _id: string
  rateLay: number
  rateBack: number
  rateCategoryId?: { name?: string; _id?: string } | string
}

type Cat = { _id: string; name: string }

export function RateListPage() {
  const toast = useToast()
  const navigate = useNavigate()
  const [list, setList] = useState<Rate[]>([])
  const [cats, setCats] = useState<Cat[]>([])
  const [catId, setCatId] = useState('')
  const [open, setOpen] = useState(false)
  const [form, setForm] = useState({ rateLay: '', rateBack: '', rateCategoryId: '' })
  const [deleteId, setDeleteId] = useState<string | null>(null)

  const load = () => {
    void sessionApi
      .getAllRates()
      .then((res) => {
        setList(Array.isArray(res.data) ? (res.data as Rate[]) : [])
      })
      .catch(() => setList([]))
  }

  useEffect(() => {
    load()
    void sessionApi
      .getAllRateCategory()
      .then((res) => {
        setCats(Array.isArray(res.data) ? (res.data as Cat[]) : [])
      })
      .catch(() => setCats([]))
  }, [])

  const filter = (id: string) => {
    setCatId(id)
    if (!id) {
      load()
      return
    }
    const cat = cats.find((c) => c._id === id)
    if (!cat) return
    void sessionApi.filterRatesAndCatgData(cat).then((res) => {
      const raw = res.data as { data?: Rate[] } | Rate[]
      const data = Array.isArray(raw) ? raw : raw?.data
      setList(Array.isArray(data) ? data : [])
    })
  }

  return (
    <div>
      <PageHead
        title="Rate List"
        onBack={() => navigate('/sessionmarket')}
        actions={
          <Button variant="primary" onClick={() => setOpen(true)}>
            Create Rate
          </Button>
        }
      />
      <div className="sm-row" style={{ marginBottom: 12 }}>
        <select className="w7-input" value={catId} onChange={(e) => filter(e.target.value)}>
          <option value="">Select Rate Category</option>
          {cats.map((c) => (
            <option key={c._id} value={c._id}>
              {c.name}
            </option>
          ))}
        </select>
      </div>
      <div className="sm-card">
        <table className="w7-table">
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Rate Category</th>
              <th>RateLay</th>
              <th>RateBack</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {!list.length ? (
              <tr>
                <td colSpan={5}>No Rates found</td>
              </tr>
            ) : (
              list.map((rate, i) => (
                <tr key={rate._id}>
                  <td>{i + 1}</td>
                  <td>
                    {typeof rate.rateCategoryId === 'object' ? rate.rateCategoryId?.name : ''}
                  </td>
                  <td>{rate.rateLay}</td>
                  <td>{rate.rateBack}</td>
                  <td>
                    <Button size="sm" variant="danger" onClick={() => setDeleteId(rate._id)}>
                      Delete
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Create Rate"
        footer={
          <Button
            variant="primary"
            onClick={() =>
              void sessionApi
                .saveRate({
                  rateLay: Number(form.rateLay),
                  rateBack: Number(form.rateBack),
                  rateCategoryId: form.rateCategoryId,
                })
                .then(() => {
                  toast.success('Rate saved')
                  setOpen(false)
                  load()
                })
                .catch(() => toast.error('Failed'))
            }
          >
            Save
          </Button>
        }
      >
        <div className="w7-col" style={{ gap: 8 }}>
          <select
            className="w7-input"
            value={form.rateCategoryId}
            onChange={(e) => setForm((f) => ({ ...f, rateCategoryId: e.target.value }))}
          >
            <option value="">Category</option>
            {cats.map((c) => (
              <option key={c._id} value={c._id}>
                {c.name}
              </option>
            ))}
          </select>
          <Input
            placeholder="Rate Lay"
            value={form.rateLay}
            onChange={(e) => setForm((f) => ({ ...f, rateLay: e.target.value }))}
          />
          <Input
            placeholder="Rate Back"
            value={form.rateBack}
            onChange={(e) => setForm((f) => ({ ...f, rateBack: e.target.value }))}
          />
        </div>
      </Modal>

      <Modal
        open={!!deleteId}
        onClose={() => setDeleteId(null)}
        title="Delete Rate"
        footer={
          <Button
            variant="danger"
            onClick={() => {
              if (!deleteId) return
              void sessionApi.deleteOneRate({ _id: deleteId }).then(() => {
                toast.success('Rate deleted')
                setDeleteId(null)
                load()
              })
            }}
          >
            Delete
          </Button>
        }
      >
        <p>Delete this rate?</p>
      </Modal>
    </div>
  )
}
